<div class="rx-intuitive-implant-position-modal">
	<tlk-modal-header>
		{{ 'UnitTypes.ImplantPosition' | translate }}
		<button tlkButton variant="ghost" size="l" right-icon (click)="handleCancel()"><tlk-close-empty-icon class="tlk-icon_size_l"/></button>
	</tlk-modal-header>

	<tlk-modal-content [style.--tlk-modal-content-padding]="'0'">
	<rx-intuitive-mini-teeth-diagram
		[teeth]="teeth"
		[numberPosition]="'below'"
	></rx-intuitive-mini-teeth-diagram>
		<div class="implant-position-container">
			<rx-implant-position
				[implantTypeId]="currentImplantTypeId"
				(implantTypeIdChange)="handleImplantTypeIdChange($event)"
				[isReadOnly]="false"
			></rx-implant-position>
		</div>
	</tlk-modal-content>

	<tlk-modal-footer>
		<ng-container ngProjectAs="[right-buttons]">
			<button tlkButton variant="secondary" size="m" (click)="handleClose()">
				{{ 'Done' | translate }}
			</button>
		</ng-container>
	</tlk-modal-footer>
</div>
